import React, { useRef, useState } from "react"
import { useAuth } from '../../../contexts/AuthContext';
import styles from './Dashboard.module.scss';

export default function ChangeUsernameForm({ currentUsername, onSaved }) {
    const usernameRef = useRef();
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);
    const { updateUsername } = useAuth();

    async function handleSubmit(e) {
        e.preventDefault();
        setError('');
        setLoading(true);

        try {
            const result = await updateUsername(usernameRef.current.value.trim());
            if (!result.success) {
                setError(result.error);
            } else {
                onSaved?.();
            }
        } catch (err) {
            setError('Failed to update username');
        } finally {
            setLoading(false);
        }
    }

    return (
        <>
            {error && <div className={styles.error}>{error}</div>}
            <form onSubmit={handleSubmit}>
                <label>New username</label>
                <input ref={usernameRef} type="text" defaultValue={currentUsername} required minLength={3} autoFocus/>
                <button type="submit" className={styles.button} disabled={loading}>
                    {loading ? 'Saving...' : 'Save'}
                </button>
            </form>
        </>
    )
}
